












import {Component, Prop, Vue, Watch} from 'vue-property-decorator';

@Component({})
export default class Shortcut extends Vue {
  public isActive = false;

  @Prop() public icon!: string;
  @Prop() public title!: string;
  @Prop() public routes!: any[];
  @Prop() public to!: string;

  public mounted() {
    this.updateActive(this.$route);
  }

  public beforeUpdate() {
    this.updateActive(this.$route);
  }

  public updateActive(route: any) {
    this.isActive = this.routes && this.routes.find((x) => x === route.name);
  }

  @Watch('$route')
  public onRouteChanged(newRoute: any) {
    this.updateActive(newRoute);
  }
}
